module.exports = __webpack_public_path__ + "static/media/airplane-2-multi-size.bbd41372.ico";